import { render, staticRenderFns } from "./BibleCallControls.vue?vue&type=template&id=a8efaae6&scoped=true"
import script from "./BibleCallControls.vue?vue&type=script&lang=js"
export * from "./BibleCallControls.vue?vue&type=script&lang=js"
import style0 from "./BibleCallControls.vue?vue&type=style&index=0&id=a8efaae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8efaae6",
  null
  
)

export default component.exports